import { createNamespacedHelpers } from 'vuex';

const imageMapper = createNamespacedHelpers('trainer/image');
const globalMapper = createNamespacedHelpers('global');
import { showConfirmSwal } from '@/util/swal';

import showToast from '@/util/toast';

const GOOD_CLASS = '0';
const SLIDE_INTERVAL = 3000;

export default {
	name: 'ImagesListModal',
	data() {
		return {
			GOOD_CLASS: GOOD_CLASS,
			myInterval: null,
			slideShow: 0,
			slideInterval: SLIDE_INTERVAL
		};
	},

	props: {
		images: {
			type: Object,
			default: () => {
				return {
					imagesList: [],
					from: '',
				};
			},
		},
		modalId: {
			type: String,
		},
		slide: {
			type: Number,
		},
		hasBorder: {
			type: Boolean,
		},
		hasTag: {
			type: Boolean,
		},
	},

	computed: {
		...imageMapper.mapGetters(['reversedImages',]),
		slideCount: {
			get() {
				return this.slide;
			},
			set(val) {
				this.$emit('update:slide', val);
			},
		},
		newImagesList() {
			return this.images.imagesList.map((image) => {
				return {
					...image,
					hasBorder: this.hasBorder,
					hasTag: this.hasTag,
				};
			});
		},

		newImagesListLength() {
			return this.newImagesList.length;
		},

		autoSlide: {
			get() {
				return this.$store.state.trainer.autoSlide;
			},
			set() {
				this.$store.dispatch('trainer/switchAutoSlide')
			}
		}
	},

	watch: {
		images() {
			if (this.images.imagesList.length == 0) {
				this.$bvModal.hide(this.modalId)
			}
		}
	},

	methods: {
		...imageMapper.mapActions([
			'deleteImage',
		]),
		...globalMapper.mapActions(['setSpinner']),
		...imageMapper.mapMutations(['SET_STEP2']),


		openModal() {
			this.$bvModal.show('carousel-modal');
		},

		onShown() {
			this.insertCustomElement();
		},

		insertCustomElement() {
			this.myInterval = setInterval(() => {
				const carousels =
					document.getElementsByClassName('carouselImage');

				if (carousels.length > 0) {
					clearInterval(this.myInterval);
					// Lặp qua các phần tử image trong newImagesList
					this.newImagesList.forEach((image, idx) => {
						let template = `<div class="${!image.hasTag
							? ''
							: image.class === GOOD_CLASS
								? 'carouselImage--goodTag'
								: 'carouselImage--badTag'
							}"
                  >
                    ${!image.hasTag
								? ''
								: `<h3>
                      ${image.class === GOOD_CLASS ? 'OK' : 'NG'}
                      </h3>`
							}
                </div>`;

						carousels[idx].insertAdjacentHTML('beforeend', template);
					});
				}
			}, 10);
		},

		onDeleteImage(image, idx, event) {
			event.stopPropagation();

			const deleteItem = async () => {
				this.setSpinner(true);
				try {
					await this.deleteImage({
						username: this.username,
						file_name: image.imageName,
						s3_key: image.imageKey,
						image_type: image.imageType,
						id: image.imageId,
						index: idx,
					});
					this.setSpinner(false);

					showToast({
						vueInstance: this,
						type: 'success',
						message: this.$t('successDeleteImage'),
					});
					this.SET_STEP2();

				} catch (error) {
					this.setSpinner(false);
					showToast({
						vueInstance: this,
						type: 'danger',
						message: this.$t('failDeleteImage'),
					});
				}
			};

			showConfirmSwal(
				{
					title: this.$t('confirnDelete'),
					text: this.$t('confirmDeleteImage'),
					yesButton: this.$t('confirmYes'),
					noButton: this.$t('confirmNo'),
				},
				deleteItem,
				() => { }
			);
		},

		closeModal() {
			this.$bvModal.hide(this.modalId);
		},
	},

	mounted() { },

	watch: {
		autoSlide: function (val) {
			if (val === true) {
				this.slideShow = this.slideInterval;
			}
			else this.slideShow = 0
		}
	}
};
